
<div class="permissionsection" >
  @if (rbainitaldata?.isCustomerAdmin) {
    <div class=adminsection>
      <div class="col-xs-12 col-sm-12 no-padding myprofile_tabContentHeader adminpermission">{{"permission.admintxt" | cxTranslate}}</div>
      <!-- permission toggle btn -->
      <div class="col-xs-12 no-padding per_locationt1">
        <div class="col-xs-12 no-padding perlocationcont">
          <!-- user view dropdow-->
          <div class="col-xs-7 no-padding adminUserView" [ngClass]="admintabsection.user?'active':''">
            <div class=" col-xs-12 per_locationdropdow">
              <div class="permission_droptext">{{"permission.userstext" | cxTranslate}}</div>
              <div class="permission_drop_box">
                <select class="Permission_dropdown" name="Permission_User" id="Permision_User" (change)="userselchange()">
                  @for (item of rbainitaldata?.customersRBAData; track item; let i = $index) {
                    <option value={{item.userId}} id="Per_user-{{i}}">{{item.userName}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <!-- user view dropdow Ends-->
          <div class="col-xs-7 no-padding adminAccountView" [ngClass]="admintabsection.account?'active':''"><div class="permission_droptext">{{"permission.permissiontext" | cxTranslate}}</div></div>
          <div class="col-xs-7 no-padding adminLocationView"  [ngClass]="admintabsection.location?'active':''">
            <div class=" col-xs-12 per_locationdropdow">
              <div class="permission_droptext">{{"permission.locstxt" | cxTranslate}}</div>
              <div class="permission_drop_box">
                <select class="Permission_dropdown" name="Permission_location" id="Permision_location" (change)="locationselchange()">
                  @for (item of rbainitaldata?.custLocationPermission; track item; let i = $index) {
                    <option value={{item.locID}} id="Per_location-{{i}}">{{item.location}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-xs-5 viewtoggle viewselection">
            <div class="viewtext">{{"permission.viewbytext" | cxTranslate}}</div>
            <div class="permissionradioparent">
              <div class="settingradioholder ">
                <input type="radio" class="permission_radiobtn" id="Viewby0" name="Viewby" [checked]="rbainitaldata.userPermissionView=='Account'?'checked':''" value="ACCOUNT" (change)="toggleview('ACCOUNT')">
                <label class="permissionlabel" for="Viewby0">{{"permission.acctext" | cxTranslate}}</label>
              </div>
              <div class="settingradioholder">
                <input type="radio" class="permission_radiobtn viewByRadio viewBySetting" id="Viewby1" [checked]="rbainitaldata.userPermissionView=='Location'?'checked':''"  name="Viewby" value="LOCATION" (change)="toggleview('LOCATION')">
                <label class="permissionlabel" for="Viewby1">{{"permission.loctext" | cxTranslate}}</label>
              </div>
              <div class="settingradioholder">
                <input type="radio" class="permission_radiobtn viewByRadio viewBySetting" id="Viewby2"  name="Viewby"  [checked]="rbainitaldata.userPermissionView=='User'?'checked':''"value="USER" (change)="toggleview('USER')">
                <label class="permissionlabel" for="Viewby2">{{"permission.usertext" | cxTranslate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" col-xs-12 no-padding per_locationt2">
        @if (admintabsection.account) {
          <div class="adminpermission_locationtable">
            <div class="tablecustomheader">
              <div class="customheaderfirst customheaderdiv">{{"permission.usertext" | cxTranslate}}</div>
              <div class="customheaderdiv customAccountFirst">
                {{"permission.accpermissiontext" | cxTranslate}}<div class="uktooltip">
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
                  <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
                </svg>
                <span>{{"permission.accpermissionmsg" | cxTranslate}}</span>
              </div>
            </div>
            <div class="customheaderdiv customAccountDiv">
              {{"permission.adminpermissiontext" | cxTranslate}}<div class="uktooltip">
              <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
                <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
              </svg>
              <span>{{"permission.adminpermissionmsg" | cxTranslate}}</span>
            </div>
          </div>
        </div>
        <div class="adminscrolltable">
          <table mat-table [dataSource]="adminaccount" class="admintable">
            <ng-container matColumnDef="userName">
              <td mat-cell *matCellDef="let element">{{element.userName}} </td>
            </ng-container>
            <ng-container matColumnDef="accountPermissions">
              <td mat-cell *matCellDef="let element;let i = index"><div class="permissionradioparent">
                <div class="radioholder">
                  <input type="radio" class="permission_radiobtn" id="accountpermission_new0{{i}}" name="accountpermission_new{{i}}" [checked]="element.accountPermissions=='NONE'?'checked':''" value="NONE"  (change)="accountpermssiontoggle(element.userId,'accountPermissions','NONE')">
                  <label class="permissionlabel" for="accountpermission_new0{{i}}">{{"permission.nonetext" | cxTranslate}}</label>
                </div>
                <div class="radioholder">
                  <input type="radio" class="permission_radiobtn" id="accountpermission_new1{{i}}" name="accountpermission_new{{i}}" [checked]="element.accountPermissions=='VIEWONLY'?'checked':''" value="VIEWONLY" (change)="accountpermssiontoggle(element.userId,'accountPermissions','VIEWONLY')">
                  <label class="permissionlabel" for="accountpermission_new1{{i}}">{{"permission.viewonlytext" | cxTranslate}}</label>
                </div>
                <div class="radioholder ">
                  <input type="radio" class="permission_radiobtn" id="accountpermission_new2{{i}}" name="accountpermission_new{{i}}" [checked]="element.accountPermissions=='MANAGE'?'checked':''" value="MANAGE" (change)="accountpermssiontoggle(element.userId,'accountPermissions','MANAGE')">
                  <label class="permissionlabel" for="accountpermission_new2{{i}}">{{"permission.managetext" | cxTranslate}}</label>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="adminPermissions">
            <td mat-cell *matCellDef="let element;let i = index">
              <div class="permissionradioparent">
                <div class="radioholder">
                  <input type="radio" class="permission_radiobtn" id="adminPermissions0{{i}}" name="adminPermissions{{i}}" [checked]="element.adminPermissions=='NONE'?'checked':''" value="NONE" (change)="accountpermssiontoggle(element.userId,'adminPermissions','NONE')">
                  <label class="permissionlabel" for="adminPermissions0{{i}}">{{"permission.nonetext" | cxTranslate}}</label>
                </div>
                <div class="radioholder ">
                  <input type="radio" class="permission_radiobtn" id="adminPermissions2{{i}}" name="adminPermissions{{i}}" [checked]="element.adminPermissions=='MANAGE'?'checked':''" value="MANAGE" (change)="accountpermssiontoggle(element.userId,'adminPermissions','MANAGE')">
                  <label class="permissionlabel" for="adminPermissions2{{i}}">{{"permission.managetext" | cxTranslate}}</label>
                </div>
              </div></td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedaccount;">
            </tr>
          </table>
        </div>
        <div ></div>
      </div>
    }
    <!-- location table -->
    @if (admintabsection.location) {
      <div class="adminpermission_locationtable">
        <div class="tablecustomheader">
          <div class="customheaderfirst customheaderdiv">{{"permission.usertext" | cxTranslate}}</div>
          <div class="customheaderdiv">
            {{"permission.orderpermission" | cxTranslate}}<div class="uktooltip">
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
              <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
            </svg>
            <span>{{"permission.orderpermissionmsg" | cxTranslate}}</span>
          </div>
        </div>
        <div class="customheaderdiv customthirddiv">
          {{"permission.financepermission" | cxTranslate}}<div class="uktooltip">
          <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
            <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
          </svg>
          <span>{{"permission.financepermissionmsg" | cxTranslate}}</span>
        </div>
      </div>
    </div>
    <div class="adminscrolltable">
      <table mat-table [dataSource]="adminlocataion" class="admintable">
        <ng-container matColumnDef="userName">
          <td mat-cell *matCellDef="let element">{{element.userName}} </td>
        </ng-container>
        <ng-container matColumnDef="orderingPermissions">
          <td mat-cell *matCellDef="let element;let i = index"><div class="permissionradioparent">
            <div class="radioholder">
              <input type="radio" class="permission_radiobtn" id="locationpermission_new0{{i}}" name="locationpermission_new{{i}}" [checked]="element.orderingPermissions=='NONE'?'checked':''" value="NONE" (change)="locpermissiontoggle(element.userId,'orderingPermissions','NONE')">
              <label class="permissionlabel" for="locationpermission_new0{{i}}">{{"permission.nonetext" | cxTranslate}}</label>
            </div>
            <div class="radioholder">
              <input type="radio" class="permission_radiobtn" id="locationpermission_new1{{i}}" name="locationpermission_new{{i}}" [checked]="element.orderingPermissions=='VIEWONLY'?'checked':''" value="VIEWONLY" (change)="locpermissiontoggle(element.userId,'orderingPermissions','VIEWONLY')" >
              <label class="permissionlabel" for="locationpermission_new1{{i}}">{{"permission.viewonlytext" | cxTranslate}}</label>
            </div>
            <div class="radioholder ">
              <input type="radio" class="permission_radiobtn" id="locationpermission_new2{{i}}" name="locationpermission_new{{i}}" [checked]="element.orderingPermissions=='MANAGE'?'checked':''" value="MANAGE"  (change)="locpermissiontoggle(element.userId,'orderingPermissions','MANAGE')">
              <label class="permissionlabel" for="locationpermission_new2{{i}}">{{"permission.managetext" | cxTranslate}}</label>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="financialPermission">
        <td mat-cell *matCellDef="let element;let i = index">
          <div class="permissionradioparent">
            <div class="radioholder">
              <input type="radio" class="permission_radiobtn" id="financialPermission0{{i}}" name="financialPermission{{i}}" [checked]="element.financialPermission=='NONE'?'checked':''" value="NONE" (change)="locpermissiontoggle(element.userId,'financialPermission','NONE')" >
              <label class="permissionlabel" for="financialPermission0{{i}}">{{"permission.nonetext" | cxTranslate}}</label>
            </div>
            <div class="radioholder">
              <input type="radio" class="permission_radiobtn" id="financialPermission1{{i}}" name="financialPermission{{i}}" [checked]="element.financialPermission=='VIEWONLY'?'checked':''" value="VIEWONLY" (change)="locpermissiontoggle(element.userId,'financialPermission','VIEWONLY')">
              <label class="permissionlabel" for="financialPermission1{{i}}">{{"permission.viewonlytext" | cxTranslate}}</label>
            </div>
            <div class="radioholder ">
              <input type="radio" class="permission_radiobtn" id="financialPermission2{{i}}" name="financialPermission{{i}}" [checked]="element.financialPermission=='MANAGE'?'checked':''" value="MANAGE" (change)="locpermissiontoggle(element.userId,'financialPermission','MANAGE')">
              <label class="permissionlabel" for="financialPermission2{{i}}">{{"permission.managetext" | cxTranslate}}</label>
            </div>
          </div></td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedlocation;">
        </tr>
      </table>
    </div>
  </div>
}
<!-- user section table -->
@if (admintabsection.user) {
  <table class="useraccounttable">
    <thead>
      <tr>
        <th>{{"permission.acctext" | cxTranslate}}</th>
        <th>{{"permission.accpermissiontext" | cxTranslate}}<div class="uktooltip">
          <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
            <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
          </svg>
          <span>{{"permission.accpermissionmsg" | cxTranslate}}</span>
        </div>
      </th>
      <th>{{"permission.adminpermissiontext" | cxTranslate}}<div class="uktooltip">
        <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
          <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
        </svg>
        <span>{{"permission.adminpermissionmsg" | cxTranslate}}</span>
      </div>
    </th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>{{rbainitaldata?.companyName}}</td>
    <td class="accountPermissions">
      <div class="permissionradioparent">
        <div class="userradioholder">
          <input type="radio" class="permission_radiobtn_user" id="useraccper0" name="useraccper" value="NONE" [checked]="useraccountpermission=='NONE'?'checked':''"  (change)="adminpermssiontoggle('accountPermissions','NONE')">
          <label class="permissionlabel" for="useraccper0">{{"permission.nonetext" | cxTranslate}}</label>
        </div>
        <div class="userradioholder">
          <input type="radio" class="permission_radiobtn_user" id="useraccper1" name="useraccper" value="VIEWONLY" [checked]="useraccountpermission=='VIEWONLY'?'checked':''" (change)="adminpermssiontoggle('accountPermissions','VIEWONLY')">
          <label class="permissionlabel" for="useraccper1">{{"permission.viewonlytext" | cxTranslate}}</label>
        </div>
        <div class="userradioholder ">
          <input type="radio" class="permission_radiobtn_user" id="useraccper2" name="useraccper" value="MANAGE" [checked]="useraccountpermission=='MANAGE'?'checked':''" (change)="adminpermssiontoggle('accountPermissions','MANAGE')" >
          <label class="permissionlabel" for="useraccper2">{{"permission.managetext" | cxTranslate}}</label>
        </div>
      </div>
    </td>
    <td class="adminPermissions">
      <div class="permissionradioparent">
        <div class="userradioholder ">
          <input type="radio" class="permission_radiobtn_userAdmin" id="useradminper0" name="useradminper" value="NONE" [checked]="useradminpermission=='NONE'?'checked':''" (change)="adminpermssiontoggle('adminPermissions','NONE')">
          <label class="permissionlabel" for="useradminper0">{{"permission.nonetext" | cxTranslate}}</label>
        </div>
        <div class="userradioholder">
          <input type="radio" class="permission_radiobtn_userAdmin" id="useradminper1" name="useradminper" value="MANAGE" [checked]="useradminpermission=='MANAGE'?'checked':''" (change)="adminpermssiontoggle('adminPermissions','MANAGE')" >
          <label class="permissionlabel" for="useradminper1">{{"permission.managetext" | cxTranslate}}</label>
        </div>
      </div>
    </td>
  </tr>
</tbody>
</table>
<div class="adminpermission_locationtable">
  <div class="tablecustomheader adminuserheader">
    <div class="usercustomheader customheaderdiv">{{"permission.loctext" | cxTranslate}}</div>
    <div class="usercustomheader customheaderdiv">{{"permission.postcodelabel" | cxTranslate}}</div>
    <div class="customheaderdiv usercustomheader">
      {{"permission.orderpermission" | cxTranslate}}<div class="uktooltip">
      <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
        <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
      </svg>
      <span>{{"permission.orderpermissionmsg" | cxTranslate}}</span>
    </div>
  </div>
  <div class="customheaderdiv usercustomheader">
    {{"permission.financepermission" | cxTranslate}}<div class="uktooltip">
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
      <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
    </svg>
    <span>{{"permission.financepermissionmsg" | cxTranslate}}</span>
  </div>
</div>
</div>
<div class="adminscrolltable">
  <table mat-table [dataSource]="adminuser" class="admintable usertable">
    <ng-container matColumnDef="location">
      <td mat-cell *matCellDef="let element">{{element.location}} </td>
    </ng-container>
    <ng-container matColumnDef="postCode">
      <td mat-cell *matCellDef="let element">{{element.postCode}} </td>
    </ng-container>
    <ng-container matColumnDef="orderingPermissions">
      <td mat-cell *matCellDef="let element;let i = index"><div class="permissionradioparent">
        <div class="radioholder">
          <input type="radio" class="permission_radiobtn" id="userpermission_new0{{i}}" name="userpermission_new{{i}}" [checked]="element.orderingPermissions=='NONE'?'checked':''" value="NONE" (change)="locpermissiontoggle(element.locID,'orderingPermissions','NONE')">
          <label class="permissionlabel" for="userpermission_new0{{i}}">{{"permission.nonetext" | cxTranslate}}</label>
        </div>
        <div class="radioholder">
          <input type="radio" class="permission_radiobtn" id="userpermission_new1{{i}}" name="userpermission_new{{i}}" [checked]="element.orderingPermissions=='VIEWONLY'?'checked':''" value="VIEWONLY" (change)="locpermissiontoggle(element.locID,'orderingPermissions','VIEWONLY')" >
          <label class="permissionlabel" for="userpermission_new1{{i}}">{{"permission.viewonlytext" | cxTranslate}}</label>
        </div>
        <div class="radioholder ">
          <input type="radio" class="permission_radiobtn" id="userpermission_new2{{i}}" name="userpermission_new{{i}}" [checked]="element.orderingPermissions=='MANAGE'?'checked':''" value="MANAGE" (change)="locpermissiontoggle(element.locID,'orderingPermissions','MANAGE')">
          <label class="permissionlabel" for="userpermission_new2{{i}}">{{"permission.managetext" | cxTranslate}}</label>
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="financialPermission">
    <td mat-cell *matCellDef="let element;let i = index">
      <div class="permissionradioparent">
        <div class="radioholder">
          <input type="radio" class="permission_radiobtn" id="userfinancialPermission0{{i}}" name="userfinancialPermission{{i}}" [checked]="element.financialPermission=='NONE'?'checked':''" value="NONE" (change)="locpermissiontoggle(element.locID,'financialPermission','NONE')">
          <label class="permissionlabel" for="userfinancialPermission0{{i}}">{{"permission.nonetext" | cxTranslate}}</label>
        </div>
        <div class="radioholder">
          <input type="radio" class="permission_radiobtn" id="userfinancialPermission1{{i}}" name="userfinancialPermission{{i}}" [checked]="element.financialPermission=='VIEWONLY'?'checked':''" value="VIEWONLY" (change)="locpermissiontoggle(element.locID,'financialPermission','VIEWONLY')">
          <label class="permissionlabel" for="userfinancialPermission1{{i}}">{{"permission.viewonlytext" | cxTranslate}}</label>
        </div>
        <div class="radioholder ">
          <input type="radio" class="permission_radiobtn" id="userfinancialPermission2{{i}}" name="userfinancialPermission{{i}}" [checked]="element.financialPermission=='MANAGE'?'checked':''" value="MANAGE" (change)="locpermissiontoggle(element.locID,'financialPermission','MANAGE')">
          <label class="permissionlabel" for="userfinancialPermission2{{i}}">{{"permission.managetext" | cxTranslate}}</label>
        </div>
      </div></td>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: displayeduser;">
    </tr>
  </table>
</div>
</div>
}
</div>
<!-- setting section -->
<div class="col-xs-12 no-padding per_locationt3">
  <div class="settingtext">{{"permission.settingtxt" | cxTranslate}}</div>
  <div class="intialview">{{"permission.initialtable" | cxTranslate}}<div class="uktooltip">
    <svg width="19" height="19" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
      <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
    </svg>
    <span>{{"permission.initialviewmsg" | cxTranslate}}</span>
  </div>
</div>
<div class="permissionradioparent initialviewtable">
  <div class="settingradioholder">
    <input type="radio" class="initialpermission_radiobtn settingradio" id="Newuser_view0" name="Newuser_view" value="ACCOUNT" [checked]="rbainitaldata.userPermissionView=='Account'?'checked':''" (change)="settingtoggle('Account','initialviewtable')">
    <label class="permissionlabel" for="Newuser_view0">{{"permission.acctext" | cxTranslate}}</label>
  </div>
  <div class="settingradioholder">
    <input type="radio" class="initialpermission_radiobtn settingradio" id="Newuser_view1" name="Newuser_view" value="LOCATION" [checked]="rbainitaldata.userPermissionView=='Location'?'checked':''" (change)="settingtoggle('Location','initialviewtable')">
    <label class="permissionlabel" for="Newuser_view1">{{"permission.loctext" | cxTranslate}}</label>
  </div>
  <div class="settingradioholder ">
    <input type="radio" class="initialpermission_radiobtn settingradio" id="Newuser_view2" name="Newuser_view" value="USER" [checked]="rbainitaldata.userPermissionView=='User'?'checked':''" (change)="settingtoggle('User','initialviewtable')">
    <label class="permissionlabel" for="Newuser_view2">{{"permission.usertext" | cxTranslate}}</label>
  </div>
</div>
<div class="intialview newuserview">{{"permission.initialpermission" | cxTranslate}}<div class="uktooltip">
  <svg width="19" height="19" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
    <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
  </svg>
  <span [innerHTML]="'permission.initialpermissionmsg' | cxTranslate"></span>
</div>
</div>
<div class="col-xs-6 no-padding newpermission ordering_permission">
  <div class="newpermissionText">{{"permission.orderingtxt" | cxTranslate}}</div>
  <div class="permissionradioparent orderingPermissions">
    <div class="settingradioholder">
      <input type="radio" class="orderingpermission_radiobtn settingradio" id="Ordering_new0" name="Ordering_new" value="NONE" [checked]="rbainitaldata?.newUserInitialOrderingPermission=='NONE'?'checked':''" (change)="settingtoggle('NONE','orderingPermissions')">
      <label class="permissionlabel" for="Ordering_new0">{{"permission.nonetext" | cxTranslate}}</label>
    </div>
    <div class="settingradioholder ">
      <input type="radio" class="orderingpermission_radiobtn settingradio" id="Ordering_new1" name="Ordering_new" value="VIEWONLY" [checked]="rbainitaldata?.newUserInitialOrderingPermission=='VIEWONLY'?'checked':''" (change)="settingtoggle('VIEWONLY','orderingPermissions')">
      <label class="permissionlabel" for="Ordering_new1">{{"permission.viewonlytext" | cxTranslate}}</label>
    </div>
    <div class="settingradioholder">
      <input type="radio" class="orderingpermission_radiobtn settingradio" id="Ordering_new2" name="Ordering_new" value="MANAGE" [checked]="rbainitaldata?.newUserInitialOrderingPermission=='MANAGE'?'checked':''" (change)="settingtoggle('MANAGE','orderingPermissions')">
      <label class="permissionlabel" for="Ordering_new2">{{"permission.managetext" | cxTranslate}}</label>
    </div>
  </div>
</div>
<div class="col-xs-6 no-padding newpermission Financial_permission">
  <div class="newpermissionText">{{"permission.financialtxt" | cxTranslate}}</div>
  <div class="permissionradioparent financialPermission">
    <div class="settingradioholder">
      <input type="radio" class="financialpermission_radiobtn settingradio" id="Financial_new0" name="Financial_new" value="NONE" [checked]="rbainitaldata?.newUserInitialFinancialPermission=='NONE'?'checked':''" (change)="settingtoggle('NONE','financialPermission')">
      <label class="permissionlabel" for="Financial_new0">{{"permission.nonetext" | cxTranslate}}</label>
    </div>
    <div class="settingradioholder ">
      <input type="radio" class="financialpermission_radiobtn settingradio" id="Financial_new1" name="Financial_new" value="VIEWONLY" [checked]="rbainitaldata?.newUserInitialFinancialPermission=='VIEWONLY'?'checked':''" (change)="settingtoggle('VIEWONLY','financialPermission')">
      <label class="permissionlabel" for="Financial_new1">{{"permission.viewonlytext" | cxTranslate}}</label>
    </div>
    <div class="settingradioholder">
      <input type="radio" class="financialpermission_radiobtn settingradio" id="Financial_new2" name="Financial_new" value="MANAGE" [checked]="rbainitaldata?.newUserInitialFinancialPermission=='MANAGE'?'checked':''" (change)="settingtoggle('MANAGE','financialPermission')">
      <label class="permissionlabel" for="Financial_new2">{{"permission.managetext" | cxTranslate}}</label>
    </div>
  </div>
</div>
</div>
</div>
}


@if (!rbainitaldata?.isCustomerAdmin) {
  <div class="">
    <div class="col-xs-12 col-sm-12 no-padding myprofile_tabContentHeader nonadminpermission">{{"permission.mypermission" | cxTranslate}}</div>
    <div class="col-xs-12 col-sm-12 permissiontable1">
      <div class="permission_text">{{"permission.mypermissiontxt" | cxTranslate}}</div>
      <div class="permission_text padding-T5">{{"permission.mypermissionsubtxt" | cxTranslate}}</div>
    </div>
    <div class="col-xs-12 col-sm-12 permissiontable2">
      <table class="accountnonadmin">
        <thead>
          <tr>
            <th>{{"permission.acctext" | cxTranslate}}</th>
            <th>{{"permission.accpermissiontext" | cxTranslate}}<div class="uktooltip">
              <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
                <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
              </svg>
              <span>{{"permission.accpermissionmsg" | cxTranslate}}</span>
            </div>
          </th>
          <th>{{"permission.adminpermissiontext" | cxTranslate}}<div class="uktooltip">
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
              <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
            </svg>
            <span>{{"permission.adminpermissionmsg" | cxTranslate}}</span>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{rbainitaldata?.companyName}}</td>
        <td>@if (nonadminfull?.accountPermissions=='NONE') {
          {{"permission.nonetext" | cxTranslate}}
        }
        @if (nonadminfull?.accountPermissions=='MANAGE') {
          {{"permission.managetext" | cxTranslate}}
        }
        @if (nonadminfull?.accountPermissions=='VIEWONLY') {
          {{"permission.viewonlytext" | cxTranslate}}
        }
      </td><!-- hard coded value -->
      <td>
        @if (nonadminfull?.adminPermissions=='false') {
          {{"permission.nonetext" | cxTranslate}}
        } @else {
          {{"permission.managetext" | cxTranslate}}
        }
      </td>
    </tr>
  </tbody>
</table>
</div>
<div class="col-xs-12 col-sm-12 permissiontable3">
  <div class="">
    <table id="locationnonadmin" class="nonadmin-table" mat-table [dataSource]="nonadmin" matSort (matSortChange)="announceSortChange($event)">
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by location">
          {{"permission.loctext" | cxTranslate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.location}} </td>
      </ng-container>
      <ng-container matColumnDef="postCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by postcode">
          Postcode
        </th>
        <td mat-cell *matCellDef="let element">{{element.postCode}} </td>
      </ng-container>
      <ng-container matColumnDef="orderingPermissions">
        <th mat-header-cell *matHeaderCellDef>
          {{"permission.orderpermission" | cxTranslate}}<div class="uktooltip">
          <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
            <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
          </svg>
          <span>{{"permission.orderpermissionmsg" | cxTranslate}}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{element.orderingPermissions}} </td>
    </ng-container>
    <ng-container matColumnDef="financialPermission">
      <th mat-header-cell *matHeaderCellDef>
        {{"permission.financepermission" | cxTranslate}}
        <div class="uktooltip">
          <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11.575" r="10.5" stroke="black"></circle>
            <path d="M11.448 13.5033H10.472L10.36 11.1513H11.128C12.552 11.1513 13.592 10.1753 13.592 8.86326C13.592 7.56726 12.632 6.59126 11.24 6.59126C10.136 6.59126 9.192 7.26326 9 8.31926H7.768C7.992 6.60726 9.32 5.50326 11.192 5.50326C13.256 5.50326 14.792 6.91126 14.792 8.84726C14.792 10.6393 13.48 11.9193 11.48 12.0313L11.448 13.5033ZM10.936 16.6873C10.488 16.6873 10.12 16.3353 10.12 15.8873C10.12 15.4393 10.488 15.0873 10.936 15.0873C11.384 15.0873 11.752 15.4393 11.752 15.8873C11.752 16.3353 11.384 16.6873 10.936 16.6873Z" fill="#212121"></path>
          </svg>
          <span>{{"permission.financepermissionmsg" | cxTranslate}}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{element.financialPermission}} </td>
    </ng-container>
    <ng-container matColumnDef="locID">
      <th mat-header-cell *matHeaderCellDef class="nonadminlocid">
      </th>
      <td mat-cell class="nonadminlocid" *matCellDef="let element">{{element.locID}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumnsuk;sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsuk;">
    </tr>
  </table>
</div>
</div>
<div class="col-xs-12 col-sm-12 permissiontable4">
  <div class="permissiontable4_text">
    <div class="padding-B10">{{"permission.reqchangemsg" | cxTranslate}}</div>
    @for (item of rbainitaldata?.custAdminDataList; track item) {
      <div class="centersubtext padding-B10">{{item.userName}}<span class="permissionmail">( <a href="'mailto:'+item?.userId">{{item?.userId}}</a>)</span> </div>
    }
    <div class="padding-T10" [innerHTML]="'permission.reqchangesubtxt' | cxTranslate"></div>
  </div>
</div>
</div>
}

</div>